export default __webpack_public_path__ + "static/media/monkey.5589fa8d.png";